import React from 'react';
import styles from './side-panel-header.module.scss';
import { PiStarIconSvg } from 'components/assets/Icons/pi/pi-star';
import { Divider, Heading, Icon } from '@placer-ui/components';
import { BetaTagIconSvg } from 'components/assets/Icons/pi/beta-tag';

type SidePanelHeaderProps = {
    title: string;
    onClickNewChat?: () => void;
    onClickHistory?: () => void;
    onClose?: () => void;
};

export const SidePanelHeader = ({
    title,
    onClickNewChat,
    onClickHistory,
    onClose,
}: SidePanelHeaderProps) => {
    return (
        <div className={styles.header}>
            <div className={styles.leftSide}>
                <span className={styles.piStarIcon}>
                    <PiStarIconSvg height={20} width={20} />
                </span>
                <Heading element={'h1'} variant={'h4'}>
                    {title}
                </Heading>
                <span className={styles.betaTagIcon}>
                    <BetaTagIconSvg width={36} height={16} />
                </span>
            </div>

            <div className={styles.rightSide}>
                <Icon.IconContainer
                    size="medium"
                    color="transparent"
                    onClick={onClickNewChat}
                    testId="create-new-chat"
                >
                    <Icon type="NotePencil" size={18} color="gray" />
                </Icon.IconContainer>
                <Icon.IconContainer
                    size="medium"
                    color="transparent"
                    onClick={onClickHistory}
                    testId="show-history"
                >
                    <Icon type="ClockCounterClockwise" size={18} color="gray" />
                </Icon.IconContainer>
                <Divider isVertical={true} dividerLength={'20px'} />
                <Icon.IconContainer
                    size="medium"
                    color="transparent"
                    onClick={onClose}
                    testId="close-assistant-panel"
                >
                    <Icon type="X" size={18} weight="outline" />
                </Icon.IconContainer>
            </div>
        </div>
    );
};
